import { Russian } from 'flatpickr/dist/l10n/ru';

export default {
	datePicker: {
		inline: true,
		locale: Russian,
		minDate: 'today',
		disableMobile: 'true',
	},
	masks: {
		phone: {
			mask: '+{7} (000) 000-00-00',
			lazy: false,
		},
	},
	search: {
		minInputLength: 3,
	},
};
